(() => {
  const closeLightbox = () => {
    const dialog = document.querySelector('.dc-image-lightbox');
    if (!dialog) return;
    dialog.classList.remove('is-open');
    dialog.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dc-lightbox-open');
    dialog.querySelector('img').removeAttribute('src');
  };

  const ensureLightbox = () => {
    let dialog = document.querySelector('.dc-image-lightbox');
    if (dialog) return dialog;
    dialog = document.createElement('div');
    dialog.className = 'dc-image-lightbox';
    dialog.setAttribute('aria-hidden', 'true');
    dialog.innerHTML = '<div class="dc-image-lightbox__backdrop" data-dc-lightbox-close></div><div class="dc-image-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Expanded image"><button class="dc-image-lightbox__close" type="button" aria-label="Close expanded image" data-dc-lightbox-close>×</button><img alt=""></div>';
    document.body.appendChild(dialog);
    dialog.querySelectorAll('[data-dc-lightbox-close]').forEach(control => control.addEventListener('click', closeLightbox));
    return dialog;
  };

  const openLightbox = (src, alt) => {
    if (!src) return;
    const dialog = ensureLightbox();
    const image = dialog.querySelector('img');
    image.src = src;
    image.alt = alt || 'Expanded image';
    dialog.classList.add('is-open');
    dialog.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dc-lightbox-open');
    dialog.querySelector('.dc-image-lightbox__close').focus();
  };

  const addGalleryTriggers = () => {
    document.querySelectorAll('.dc-ban-page .dc-banquette-gallery figure').forEach(figure => {
      if (figure.dataset.dcZoomReady === 'true') return;
      const image = figure.querySelector('img');
      if (!image) return;
      figure.dataset.dcZoomReady = 'true';
      figure.tabIndex = 0;
      figure.setAttribute('role', 'button');
      figure.setAttribute('aria-label', `Expand ${image.alt || 'banquette seating image'}`);
      const show = () => openLightbox(image.currentSrc || image.src, image.alt);
      figure.addEventListener('click', show);
      figure.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); show(); }
      });
    });
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-dc-zoom-src]');
    if (!trigger) return;
    event.preventDefault();
    openLightbox(trigger.dataset.dcZoomSrc, trigger.dataset.dcZoomAlt);
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeLightbox(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addGalleryTriggers);
  else addGalleryTriggers();
  document.addEventListener('shopify:section:load', addGalleryTriggers);
})();
